export enum Process {
  INITIAL = 'initial',
  PROCESSING = 'processing',
  COMPLETED = 'completed'
}
